import React from "react";
import _ from "lodash";
import Button from "Components/button/Button";
import TranslatedString from "Components/TranslatedString";
import WarningBanner from "Components/warningBanner/WarningBanner";

import t from "Utils/translation";
import cx from "classnames";
import s from "./recapArchive.scss";

export default class Recap extends React.Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);

    const domainCode = props.match.params.domainCode;

    const selectedEmailCodes = Object.keys(props.formData.email_codes);
    this.goBack = this.goBack.bind(this);
    this.state = {
      recapEmails: _.compact(
        props.totalEmails.map(em => {
          if (selectedEmailCodes.includes(em.value) && props.formData.email_codes[em.value]) {
            return em.label;
          }
        })
      ),
      isAddingDomain: !domainCode,
      recapDomain: props.totalEmails[0].label.match(/@(.*)$/)[1]
    };
  }

  submit(e) {
    e.preventDefault();
    this.props.submitForm();
  }

  goBack() {
    if (this.props.isAddingDomain) {
      this.props.goToStep(3);
    } else {
      this.props.goToStep(1);
    }
  }

  render() {
    const { formData, formErrors, isFormLoading } = this.props;
    const { isAddingDomain } = this.props;

    return (
      <div className="formsPage">
        {this.props.stepper}
        <div className={cx("sectionTitle", "titleFP")}>{t("archive.add.title.step4")}</div>
        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">
              {<TranslatedString>archive.add.desc.step4</TranslatedString>}
            </div>
            <Button
              className="btnDocsFP"
              docsKey={isAddingDomain ? "archive_domain_add" : "archive_emailAccount_add"}
              color="docs"
              sizeSmall
            >
              button.docs
            </Button>
          </div>

          <div className="wrapFormsFP">
            <div className="formsFP">
              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.domains")}</div>
                <div className={s.dataRecapt}>
                  <div>{this.state.recapDomain}</div>
                </div>
              </div>
              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.selectedMboxes")}</div>
                <div className={s.dataRecapt}>
                  {this.state.recapEmails.map(name => (
                    <div key={name}>{name}</div>
                  ))}
                </div>
              </div>
              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.storage")}</div>
                <div className={s.dataRecapt}>
                  {formData.retention === 1
                    ? `${formData.retention} ${t("detailInfo.data.year")}`
                    : `${formData.retention} ${t("detailInfo.data.years")}`}
                </div>
              </div>
              {isAddingDomain && (
                <div className={cx("inputFull2", s.sectionRecap)}>
                  <div className={s.labelRecapt}>{t("detailInfo.label.activeOnNewMboxes")}</div>
                  <div className={s.dataRecapt}>
                    {formData.default_archive ? t("detailInfo.data.yes") : t("detailInfo.data.no")}
                  </div>
                </div>
              )}
            </div>

            {formErrors.onForm && (
              <div className="warningMsgFP">
                <WarningBanner msg={formErrors.onForm} />
              </div>
            )}

            <div className="footerFP">
              <Button color="text" type="button" onClick={() => this.props.resetAndGoBack()}>
                button.cancel
              </Button>
              <Button color="green" loading={isFormLoading} onClick={this.submit}>
                button.active
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
